import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProductVariant } from '@/models/ProductVariant';
import {Attribute} from "@/models/Attribute";

@Component<ProductAttributesDialog>({})
export default class ProductAttributesDialog extends Vue {
  @Prop()
  protected product!: ProductVariant;

  protected close() {
    this.$emit('input', false);
  }

  protected getAttributeValue(attribute: Attribute) {
    if (! attribute.options) {
      return attribute.value;
    }

     for (let option of attribute.options) {
       if (option['id'] === attribute.value) {
         return option.title;
       }
     }

     return attribute.value;
  }

  get getAttributeGroups() {
    if (! this.product || ! this.product.attributes) {
      return [];
    }

    const result = this.product.attributes.reduce(function (result, attribute: Attribute) {
      if (! attribute.title) {
        return result;
      }

      const key = attribute.title;
      result[key] = result[key] || [];
      result[key].push(attribute);
      return result;
    }, Object.create(null));

    return result;
  }
}
